import {SET_MAX_STEP, SET_STEP, VALIDATE_STEP, RESET_STEP} from '../Actions/Steps.action';

const defaultState = {
	currentStep: 1,
	maxStep: 3,
};

export const steps = (state = defaultState, action) => {
	const {type, payload} = action;
	if (!payload) return state;
	let {step, valid} = payload;
	switch (action.type) {
		case SET_MAX_STEP :
		case SET_STEP:
			return {
				...state,
				...payload,
			}
		case VALIDATE_STEP : 
			const newValidatedStep = step ? {
				[step] : valid || false,
			} : {}
			return {
				...state,
				validatedStep: {
					...state.validatedStep,
					...newValidatedStep,
				}
			}
		case RESET_STEP : 
			return {
				...state,
				currentStep: defaultState.currentStep
			}
		default:
			return state;
	}
}